import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/login-banner',
            name: 'admin-login-banner',
            component: () => import(/* webpackChunkName: "page-admin-ad-management-login-banner" */ `./index.vue`),
            meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "登录页轮播图"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "广告管理"
                                        },
                                        {
                                                  name: "登录页轮播图"
                                        }
                              ]
                    }
          }
},
        },
    ],
};
